import { Flex } from 'antd'
import { useEffect, useState } from 'react'
import QrCode from 'react-qr-code'

import { useQrCodesServiceGetOrCreateQrCodeEndpoint } from 'src/api/queries'
import { QrCodeType } from 'src/api/requests'
import { Text } from 'src/components'

type Props = {
  type: QrCodeType
  content?: string
  value?: string
}

export const QRCode = ({ type, content, value }: Props) => {
  const [id, setId] = useState<string>()

  const { mutate } = useQrCodesServiceGetOrCreateQrCodeEndpoint({
    onSuccess: (data) => setId(data?.id)
  })

  useEffect(() => {
    if (content) mutate({ type, requestBody: { content } })
  }, [])

  return (
    <Flex vertical gap={8} align="center">
      <QrCode size={61} value={value ?? window.location.href} />

      {!!id && (
        <Text
          style={{
            width: 'max-content'
          }}
        >
          {id}
        </Text>
      )}
    </Flex>
  )
}
